/**
 * Videos Database can be added here.
 * You can add videos of your wish with different attributes
 * */

export const videos = [
  {
    _id: "JfVOs4VSpmA",
    title: "SPIDER-MAN: NO WAY HOME",
    description:
      "For the first time in the cinematic history of Spider-Man, our friendly neighborhood hero's identity is revealed, bringing his Super Hero responsibilities into conflict with his normal life and putting those he cares about most at risk. When he enlists Doctor Strange’s help to restore his secret, the spell tears a hole in their world, releasing the most powerful villains who’ve ever fought a Spider-Man in any universe. Now, Peter will have to overcome his greatest challenge yet, which will not only forever alter his own future but the future of the Multiverse.",
    creator: "Sony Pictures Entertainment",
    views: "74M",
    duration: "3:04",
    thumbnail: "https://i.ytimg.com/vi/JfVOs4VSpmA/hq720.jpg",
    category: "spiderman",
  },
  {
    _id: "SLD9xzJ4oeU",
    title: "Thor vs Hulk - Fight Scene - The Avengers (2012) Movie Clip HD",
    description: "All material belongs to Disney and Marvel",

    creator: "TopMovieClips",
    views: "35M",
    duration: "4:16",
    thumbnail: "https://i.ytimg.com/vi/SLD9xzJ4oeU/hq720.jpg",
    category: "hulk",
  },
  {
    _id: "aWzlQ2N6qqg",
    title:
      "Marvel Studios' Doctor Strange in the Multiverse of Madness | Official Trailer",
    description:
      "In Marvel Studios’ Doctor Strange in the Multiverse of Madness, the MCU unlocks the Multiverse and pushes its boundaries further than ever before. Journey into the unknown with Doctor Strange, who, with the help of mystical allies both old and new, traverses the mind-bending and dangerous alternate realities of the Multiverse to confront a mysterious new adversary.Doctor Strange in the Multiverse of Madness stars Benedict Cumberbatch, Chiwetel Ejiofor, Elizabeth Olsen, Benedict Wong, Xochitl Gomez, with Michael Stühlbarg, and Rachel McAdams.",

    creator: "Marvel Entertainment",
    views: "48M",
    duration: "2:16",
    thumbnail: "https://i.ytimg.com/vi/aWzlQ2N6qqg/hq720.jpg",
    category: "drStrange",
  },
  {
    _id: "tgB1wUcmbbw",
    title: "Marvel Studios' Thor: Love and Thunder | Official Teaser",
    description:
      "The film finds Thor (Chris Hemsworth) on a journey unlike anything he’s ever faced – a quest for inner peace. But his retirement is interrupted by a galactic killer known as Gorr the God Butcher (Christian Bale), who seeks the extinction of the gods. To combat the threat, Thor enlists the help of King Valkyrie (Tessa Thompson), Korg (Taika Waititi) and ex-girlfriend Jane Foster (Natalie Portman), who – to Thor’s surprise – inexplicably wields his magical hammer, Mjolnir, as the Mighty Thor. Together, they embark upon a harrowing cosmic adventure to uncover the mystery of the God Butcher’s vengeance and stop him before it’s too late. Directed by Waititi (“Thor: Ragnarok,” “Jojo Rabbit”) and produced by Kevin Feige and Brad Winderbaum, “Thor: Love and Thunder” opens in theaters July 8, 2022.",

    creator: "Marvel Entertainment",
    views: "33M",
    duration: "1:29",
    thumbnail: "https://i.ytimg.com/vi/tgB1wUcmbbw/hqdefault.jpg",
    category: "thor",
  },
  {
    _id: "izCIHQLhwrc",
    title: "Evolution of the Raimi Suit in Spider-Man Games",
    description: "spiderman evolution",

    creator: "evoPlaysTV",
    views: "10K",
    duration: "9:22",
    thumbnail: "https://i.ytimg.com/vi/izCIHQLhwrc/hq720.jpg",
    category: "spiderman",
  },
  {
    _id: "EaJwNC4u4n0",
    title:
      "Hulk VS Thanos Hindi Avengers infinity War Fight Scene Movie Clip HD",
    description:
      "Hulk VS Thanos Hindi Avengers infinity War Fight Scene Movie Clip HD",

    creator: "CoolClips4K",
    views: "3M",
    duration: "4:58",
    thumbnail: "https://i.ytimg.com/vi/EaJwNC4u4n0/hqdefault.jpg",
    category: "hulk",
  },
  {
    _id: "xjDjIWPwcPU",
    title: "Marvel Studios' Black Panther - Official Trailer",
    description: "Marvel Studios' Black Panther - Official Trailer",

    creator: "Marvel Entertainment",
    views: "50M",
    duration: "2:18",
    thumbnail: "https://i.ytimg.com/vi/xjDjIWPwcPU/hq720.jpg",
    category: "blackPanther",
  },
];
